import React, { Component } from 'react';

import { HashLink as Link } from 'react-router-hash-link';

import { name } from 'settings';
import { BackImage, StoreButtons } from 'C4';

import logo from 'assets/images/logo/logo_white.png';

// eslint-disable-next-line react/prefer-stateless-function
export default class WelcomeView extends Component {
  render() {
    const registerSuccessful = localStorage.getItem('registerSuccessful');

    return (
      <div className="welcomeView">
        <BackImage id="760" darken />
        <div className="welcomeView__Wrapper">
          <div className="logoWelcome">
            <img src={logo} alt={name} />
          </div>
          <div className="welcomeView__Wrapper__Text">
            <h1>Download the first-ever travel advisor super app.</h1>
            <p className="sub">
            </p>
              <img className="qr" src="https://front.travpromobile.com/760/qr.png" alt="qr code" />
            <p>TheSOURCE brings the most powerful travel training, marketing, sales, and event platforms into the palm of your hand. No more jumping from supplier to supplier, website to website, show to show. TheSOURCE will simultaneously save you time, remove friction from training and selling, and make you an undeniable travel expert — on an unrivaled collection of destinations and suppliers.
            </p>
            <p className="app"></p>
            <hr />
            <StoreButtons />
            {!registerSuccessful && (
              <Link to="/login/register">
                <button>Or Sign Up for the waitlist &gt;</button>
              </Link>
            )}
            {registerSuccessful && (
              <button>You have been successfully registered! You will receive more information when the app is live!</button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
